/** Origen público del marketing (sin barra final). Usado en canonical, Open Graph y JSON-LD. */
function stripTrailingSlash(u) {
  if (!u || typeof u !== "string") return "";
  return u.replace(/\/+$/, "");
}

const raw = process.env.REACT_APP_SITE_URL || "https://ekklesiaonline.app";

export const SITE_ORIGIN = stripTrailingSlash(raw);

export const SITE_NAME = "Ekklesia";

export const DEFAULT_DESCRIPTION =
  "Software de gestión para iglesias en español. Administra miembros, consolida visitantes, coordina ministerios, controla finanzas y organiza eventos desde un solo lugar. Prueba 14 días gratuita.";

/** Título corto para la home (el <title> completo añade la marca). */
export const DEFAULT_PAGE_TITLE = "Software de gestión para iglesias | Ekklesia";

/**
 * URL absoluta del sitio o de una ruta.
 * @param {string} path — ej. "/" o "/contacto"
 */
export function absoluteUrl(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${p}`;
}

/** Imagen por defecto para compartir en redes (1200×630 recomendado). */
export function defaultOgImageUrl() {
  const custom = process.env.REACT_APP_OG_IMAGE_URL;
  if (custom && /^https?:\/\//i.test(custom)) return custom;
  return `${SITE_ORIGIN}/og-default.png`;
}
